import loadImage from 'blueimp-load-image';
// import FileReader from 'filereader';

const toDataURL = (url) =>
  fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        }),
    );

export const loadImageWithOrientation = (file) => {
  return new Promise((resolve) => {
    loadImage(
      file,
      (img) => {
        img.toBlob((blob) => {
          resolve({
            ...file,
            size: file.size,
            name: file.name,
            blob,
            previewImage: img.toDataURL(),
            preview: img.toDataURL(),
          });
        });
      },
      { orientation: true, maxWidth: 800, maxHeight: 800 },
    );
  });
};
export const stripBase64FileType = (base64String) => {
  if (base64String) {
    return base64String.replace(/^data:image\/[a-z]+;base64,/, '');
  } else {
    return undefined;
  }
};

export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

export default toDataURL;
